export default __webpack_public_path__ + "static/media/rch-logo-sm.3b0039c4.png";